import React from "react";
import ContentName from "./ContentName";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { PlayCircleFilledOutlined } from "@mui/icons-material";
import { tr } from "../../../i18n";

function Vedio({ data, addSchedule, deleteSingleContent, readOnly = false }) {
  return (
    <div className="content-item" key={data.id}>
      <div className="content-image">
        {!readOnly && (
          <div className="content-del-icon">
            <DeleteOutlineIcon
              onClick={() => deleteSingleContent(data.id)}
              style={{ color: "var(--primary-color)" }}
            />
          </div>
        )}
        <video key={data.id} controls onError={(e) => console.log(e)}>
          <source src={data.url} type="video/mp4" />
        </video>
      </div>
      <div className="content-bottom">
        <ContentName data={data} readOnly={readOnly} />
        <p style={{ display: "flex", alignItems: "center" }}>
          <span>
            <PlayCircleFilledOutlined sx={{ fontSize: "15px", color: "var(--primary-color)" }} />
          </span>
          <span>{tr("Video")}</span>
        </p>
      </div>
    </div>
  );
}

export default Vedio;